import { Flex, Space } from "antd";
import styles from "./index.module.less";
import HomeLogo from "@/assets/imgs/ice_white.svg?react";
import { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import tiaozhuan from "@/assets/lottie/tiaozhuan.json";
import ProductSubNavs from "../SubNavs/Product";
import Lottie from "lottie-react";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useStore } from "@/stores";
import useHoverLottie from "@/hooks/useHoverLottie";
import SVGIcon from "@/components/SVGIcon";
import { isMobile } from "@/utils";
import MobileHeader from "./mobile";

const navs = [
  {
    name: "首页",
    id: "product",
    path: "/",
    subNavs: {
      component: <ProductSubNavs />,
    },
  },
  {
    id: "solutions",
    name: "行业案例",
    path: "/solutions",
  },
  {
    id: "news",
    name: "企业资讯",
    path: "/news",
  },
  {
    id: "cooperation",
    name: "生态合作",
    path: "/cooperation",
  },
  {
    id: "developer",
    name: "开发者",
    path: "/developer",
  },
  {
    id: "aboutUs",
    name: "关于小冰",
    path: "/aboutUs",
  },
  {
    id: "joinUs",
    name: "人才招聘",
    path: "/joinUs",
  },
  {
    id: "contactUs",
    name: "联系我们",
  },
];
const Header = () => {
  const [subNavs, setSubNavs] = useState<any>();
  useEffect(() => {
    // 向下滚动，隐藏header, 向上滚动，显示header
    const handleScroll = (event: WheelEvent) => {
      const header = document.querySelector(`.${styles.header}`) as HTMLElement;
      if (!header) return;

      if (event.deltaY > 0) {
        header.style.transform = "translateY(-100%)";
      } else {
        header.style.transform = "translateY(0)";
      }
      // 如果滚动大于0，添加类header_scrolled
      if (window.scrollY > 0) {
        header.classList.add(styles.header_scrolled);
      } else {
        header.classList.remove(styles.header_scrolled);
      }
    };
    window.addEventListener("wheel", handleScroll);
    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const appStore = useStore("app");
  useEffect(() => {
    setSubNavs(null);
    // 显示header

    const header = document.querySelector(`.${styles.header}`) as HTMLElement;
    if (header) {
      header.style.transform = "translateY(0)";
        header.classList.remove(styles.header_scrolled);
    }
  }, [location.pathname]);
  return (
    <div
      className={styles.header}
      onMouseLeave={() => {
        setSubNavs(null);
      }}
    >
      <div className={styles.header_wrapper}>
        <Flex justify="space-between" align="center" style={{ height: "100%" }}>
          <Flex
            align="center"
            gap={8}
            className={styles.logo}
            onClick={() => {
              navigate("/");
              // window.location.href = "/";
            }}
          >
            <SVGIcon icon={<HomeLogo />}/>
            
            <div className={styles.logo_text}>小冰科技</div>
          </Flex>
          <div className={styles.navs}>
            <Flex>
              {navs.map((item) => (
                <div
                  key={item.name}
                  id={item.id}
                  className={styles.nav_item}
                  onMouseEnter={() => {
                    setSubNavs(item.subNavs?.component || null);
                  }}
                  onClick={() => {
                    if (item.path) {
                      navigate(item.path);
                    } else if (item.id === "contactUs") {
                      appStore.openContactModal();
                    }
                  }}
                >
                  {item.name}
                </div>
              ))}
            </Flex>
          </div>
        </Flex>
      </div>
      <div
        className={classnames(styles.popup_navs, {
          [styles.popup_navs_open]: subNavs,
        })}
      >
        <div className={styles.popup_navs_content}>{subNavs}</div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileHeader : observer(Header);
